import { render, staticRenderFns } from "./UsuarioPerfisAcesso.vue?vue&type=template&id=0dbaef50&"
import script from "./UsuarioPerfisAcesso.vue?vue&type=script&lang=js&"
export * from "./UsuarioPerfisAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports